import { render, staticRenderFns } from "./CbsCommentWithToggle.vue?vue&type=template&id=f05cc862&scoped=true&"
import script from "./CbsCommentWithToggle.vue?vue&type=script&lang=js&"
export * from "./CbsCommentWithToggle.vue?vue&type=script&lang=js&"
import style0 from "./CbsCommentWithToggle.vue?vue&type=style&index=0&id=f05cc862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05cc862",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/CommentTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-comment-with-toggle%2FCbsCommentWithToggle.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports